<template>
  <div style="position: relative;">
    <a href="#" @click.stop="barClick(1)">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-sheet v-bind="attrs" v-on="on" v-if="submittedPercent" style="display: inline-block; position: absolute;" color="#78909C" elevation="1" height="20" :width="submittedPercent+'%'"></v-sheet>
        </template>
        <span>{{submitted}}</span>
      </v-tooltip>
    </a>
    <a href="#" @click.stop="barClick(2)">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-sheet v-bind="attrs" v-on="on" v-if="synckedPercent" :style="'display: inline-block; position: absolute; left: '+ submittedPercent + '%'" color="#66BB6A" elevation="1" height="20" :width="synckedPercent+'%'"></v-sheet>
        </template>
        <span>{{syncked}}</span>
      </v-tooltip>
    </a>
    <a href="#" @click.stop="barClick(3)">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-sheet v-bind="attrs" v-on="on" v-if="errorPercent" :style="'display: inline-block; position: absolute; left: '+ ( submittedPercent + synckedPercent )+ '%'" color="#EF5350" elevation="1" height="20" :width="errorPercent+'%'"></v-sheet>
        </template>
        <span>{{error}}</span>
      </v-tooltip>
    </a>
    <a href="#" @click.stop="barClick(4)">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-sheet v-bind="attrs" v-on="on" v-if="waitingPercent" :style="'display: inline-block; position: absolute; left: '+ ( submittedPercent + synckedPercent + errorPercent )+ '%'" color="#3F51B5" elevation="1" height="20" :width="waitingPercent+'%'"></v-sheet>
        </template>
        <span>{{error}}</span>
      </v-tooltip>
    </a>
  </div>
</template>
<script>
import { computed } from '@vue/composition-api'

export default {
  props: {
    category: {
      required: true
    },
    submitted: {
      required: true
    },
    syncked: {
      required: true
    },
    error: {
      required: true
    },
    waiting: {
      required: true
    }
  },
  setup (props, { emit }) {
    const submittedPercent = computed(() => {
      return 90 * props.submitted / (props.submitted + props.syncked + props.error + props.waiting)
    })
    const synckedPercent = computed(() => {
      return 90 * props.syncked / (props.submitted + props.syncked + props.error + props.waiting)
    })
    const errorPercent = computed(() => {
      return 90 * props.error / (props.submitted + props.syncked + props.error + props.waiting)
    })
    const waitingPercent = computed(() => {
      return 90 * props.waiting / (props.submitted + props.syncked + props.error + props.waiting)
    })

    function barClick (status) {
      emit('click', status, props.category)
    }

    return {
      submittedPercent,
      synckedPercent,
      errorPercent,
      waitingPercent,
      barClick
    }
  }
}
</script>
